// extracted by mini-css-extract-plugin
export default {"img":"Loading_img__bDm2x","loadingImage":"Loading_loadingImage__ok3Mt"};